import * as React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import { Loading } from '../loading/loading';
import { FormattedMessage } from 'react-intl';
import { ChannelStatistics } from '../channel/statistics';
import { getChannelImage } from '../../lib/helpers';
import { ChannelSchema } from '../../types/schema';
import { classes, style } from 'typestyle';
import { percent, px, rem } from 'csx';
import { centerCenter, horizontal, vertical } from 'csstips';
import { colorSubtle } from '../../theme/color';
import { ButtonPill } from '../button-pill';

export interface AccountChannelsProps {
  loading: boolean;
  channels: Array<ChannelSchema>;
}

@inject(deps)
@observer
export class AccountChannels extends Component<AccountChannelsProps> {
  render() {
    const {
      loading,
      channels,
      model: { user },
      controller,
    } = this.props;
    const { handleClickLink } = this.props.controller.ui;

    return (
      <div
        className={classes((loading || (!loading && channels.length === 0)) && AccountChannels.styles.containerLoading)}
      >
        {loading && <Loading />}
        {!loading && channels.length === 0 && <FormattedMessage id="account.channels.empty" />}
        {!loading &&
          channels.length > 0 &&
          channels.map((channel) => (
            <div key={channel.id} className={AccountChannels.styles.channel}>
              <div className={AccountChannels.styles.channelSummary}>
                <div style={{ backgroundImage: getChannelImage(channel) }} />
              </div>
              <div>
                <h4>{channel.name}</h4>
                <dl>
                  <dt>
                    <FormattedMessage id="account.channels.published_at.label" />
                  </dt>
                  <dd>
                    <FormattedMessage
                      id="account.channels.published_at.value"
                      values={{
                        published_at: new Date(channel.published_at.timestamp * 1000),
                      }}
                    />
                  </dd>
                </dl>
                <div className={AccountChannels.styles.buttons}>
                  {channel.id !== user.channel.id && (
                    <ButtonPill primary={true} onClick={() => controller.modal.changeChannel(channel)}>
                      Select
                    </ButtonPill>
                  )}
                  {channel.id === user.channel.id && (
                    <ButtonPill tertiary={true} disabled={true}>
                      Current
                    </ButtonPill>
                  )}
                  <ButtonPill href={`/account/channels/${channel.id}`} onClick={handleClickLink}>
                    <FormattedMessage id="account.channels.videos" />
                  </ButtonPill>
                </div>
              </div>
              {channel.statistics.length > 0 && <ChannelStatistics statistics={channel.statistics[0]} />}
            </div>
          ))}
      </div>
    );
  }

  static styles = {
    containerLoading: style({
      ...centerCenter,
      height: px(120),
    }),
    channel: style({
      ...horizontal,
      $nest: {
        '& dt': {
          fontSize: rem(0.75),
          color: colorSubtle.toString(),
        },
        '& dd': {
          margin: '0 0 10px',
        },
        '&:not(:last-of-type)': {
          padding: '0 0 30px 0',
          margin: '0 0 30px 0',
          borderBottom: `1px solid ${colorSubtle.fade(0.7).toString()}`,
        },
      },
    }),
    channelSummary: style({
      maxWidth: px(200),
      position: 'relative',
      $nest: {
        '& > div': {
          paddingTop: percent(100),
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          borderRadius: '50%',
        },
      },
    }),
    buttons: style(vertical, {
      alignItems: 'flex-start',
      marginRight: px(16),
      $nest: {
        '& > *': {
          marginBottom: px(12),
        },
      },
    }),
  };
}
